import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TemplateId } from 'data/templates/api';

type TemplateStore = {
  state: boolean;
  id: TemplateId;
};

const INITIAL_STATE: TemplateStore = {
  state: false,
  id: 0,
};

export const templateSlice = createSlice({
  initialState: INITIAL_STATE,
  name: '@@TEMPLATES',

  reducers: (create) => ({
    setDirtyState: create.reducer(
      (
        state,
        {
          payload: { id, _state = true, handleSuccess },
        }: PayloadAction<{
          id: TemplateId;
          _state?: boolean;
          handleSuccess?: () => void;
        }>,
      ) => {
        handleSuccess?.();

        return {
          ...state,
          id,
          state: _state,
        };
      },
    ),
  }),
});
